module.exports = __webpack_public_path__ + "img/24ne.a9e080b0.svg";